export const HERO_GRADIENT_VARIANTS = {
  blue: {
    // light: {
    //   stop1: "#dbeafe",
    //   stop2: "#bfdbfe",
    //   stop3: "#93c5fd"
    // },
    // light: {
    //   stop1: "#eceff3",
    //   stop2: "#d9dde3",
    //   stop3: "#bcc4cf"
    // },
    light: {
      stop1: "#edf2f7",
      stop2: "#dbe2ea",
      stop3: "#c7d0dc"
    },
    dark: {
      stop1: "#243b78",
      stop2: "#16224d",
      stop3: "#080d1f"
    }
  },

  slate: {
    light: {
      stop1: "#edf2f7",
      stop2: "#dbe2ea",
      stop3: "#c7d0dc"
    },
    dark: {
      stop1: "#566274",
      stop2: "#3f4a59",
      stop3: "#222831"
    }
  },

  carbon: {
    light: {
      stop1: "#f2f4f8",
      stop2: "#dde1e6",
      stop3: "#c1c7cd"
    },
    dark: {
      stop1: "#525252",
      stop2: "#393939",
      stop3: "#161616"
    }
  },

  graphite: {
    light: {
      stop1: "#eceff3",
      stop2: "#d9dde3",
      stop3: "#bcc4cf"
    },
    dark: {
      stop1: "#5b6470",
      stop2: "#404854",
      stop3: "#232a33"
    }
  }
};

export const DEFAULT_HERO_GRADIENT = "blue";

export const getHeroGradient = (
  variant = DEFAULT_HERO_GRADIENT
) => {
  return (
    HERO_GRADIENT_VARIANTS[variant] ??
    HERO_GRADIENT_VARIANTS[DEFAULT_HERO_GRADIENT]
  );
};